/**
 * VisitTracker 全域初始化器
 * 自動檢測頁面並初始化相應的追蹤功能
 */

import VisitTracker from './visitTracker.js';

class VisitTrackerInitializer {
  constructor() {
    this.trackers = new Map();
    this.init();
  }

  init() {
    // 等待 DOM 載入完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeTrackers());
    } else {
      this.initializeTrackers();
    }
  }

  initializeTrackers() {
    // 檢查是否為老師公開頁面
    this.initializeTeacherPageTracker();

    // 可以擴展其他頁面的追蹤
    // this.initializeDashboardTracker();
    // this.initializeSearchPageTracker();
  }

  initializeTeacherPageTracker() {
    const container = document.getElementById('teacher-public-page');
    if (!container) return;

    const visitTrackingData = container.dataset.visitTracking;
    if (!visitTrackingData) return;

    try {
      const data = JSON.parse(visitTrackingData);

      if (data.teacher_id) {
        const tracker = new VisitTracker();
        tracker.initialize(
          data.teacher_slug,
          data.referrer_teacher_slug,
          data.teacher_id,
          {
            referrerUrl: data.referrer_url,
            pageUrl: data.current_url,
            referrerStudent: data.referrer_student_uuid  // v3.3: 學生推薦來源
          }
        );

        // 啟動定期報告
        tracker.startPeriodicReporting();

        // 儲存追蹤器實例
        this.trackers.set('teacher-page', tracker);

        // 全域存取（用於調試）
        window.visitTracker = tracker;

        // VisitTracker initialized successfully
      }
    } catch (error) {
      console.error('Failed to initialize VisitTracker:', error);
    }
  }

  // 清理所有追蹤器
  cleanup() {
    this.trackers.forEach(tracker => {
      if (tracker.cleanup) {
        tracker.cleanup();
      }
    });
    this.trackers.clear();
  }

  // 獲取特定追蹤器
  getTracker(name) {
    return this.trackers.get(name);
  }
}

// 自動初始化
const visitTrackerInitializer = new VisitTrackerInitializer();

// 頁面卸載時清理
window.addEventListener('beforeunload', () => {
  visitTrackerInitializer.cleanup();
});

export default visitTrackerInitializer;
